// Media query hooks on useSyncExternalStore: useMediaQuery for any query, useIsMobile below 768 px, useIsCompact at or below 1100 px.
import { useSyncExternalStore } from "react";

function subscribe(query: string, onChange: () => void): () => void {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return () => undefined;
  }
  const list = window.matchMedia(query);
  list.addEventListener("change", onChange);
  return () => {
    list.removeEventListener("change", onChange);
  };
}

function matches(query: string): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(query).matches;
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => subscribe(query, onChange),
    () => matches(query),
    () => false,
  );
}

export const MOBILE_QUERY = "(max-width: 767.98px)";
export const COMPACT_QUERY = "(max-width: 1100px)";
export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

export function useIsCompact(): boolean {
  return useMediaQuery(COMPACT_QUERY);
}

export function prefersReducedMotion(): boolean {
  return matches(REDUCED_MOTION_QUERY);
}
